const DAYS = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

/** Подпись ближайшего слота: «сегодня 16:40», «завтра 10:00» или «пн, 20.09.2026 16:40». */
export function formatNearestSlotWhen(dateDmY: string, timeHm: string): string {
  const date = dateDmY.trim();
  const time = timeHm.trim();
  const seg = date.split('.').map(Number);
  if (seg.length !== 3 || seg.some((n) => Number.isNaN(n))) {
    return `${date} ${time}`.trim();
  }
  const [day, month, year] = seg;
  const slotDate = new Date(year, month - 1, day);
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  today.setHours(0, 0, 0, 0);
  tomorrow.setHours(0, 0, 0, 0);
  const cmp = new Date(slotDate);
  cmp.setHours(0, 0, 0, 0);
  if (cmp.getTime() === today.getTime()) {
    return `сегодня ${time}`;
  }
  if (cmp.getTime() === tomorrow.getTime()) {
    return `завтра ${time}`;
  }
  const dow = DAYS[slotDate.getDay()] ?? '';
  return `${dow}, ${date} ${time}`;
}
